import uniqueId from 'lodash-es/uniqueId';
import particlesJS from 'particles.js';
import React, { RefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { SlideElementProps } from '../../presentationManager/PresentationManager';
import {
  ContentBackgroundContainer as ContentBackgroundContainerBase,
  Grid,
  HeaderContainer,
} from './Grid';

// Noted: config exported directly from https://vincentgarreau.com/particles.js
const particlesJSSettings = require('./particlesjs-config.json');

//#region Styling
const particlesBackgroundColor = '#a6bdbf';
const overlayOpacity = 0.7;
const overlayGradient = `linear-gradient(to right, rgb(255,255,255) 0%, rgb(151, 177, 180) 100%)`;
const zIndices = {
  particles: 10,
  overlay: 20,
  headerBackground: 30,
};
const ContentBackgroundContainer = styled(ContentBackgroundContainerBase)`
  position: relative;
`;
const CanvasContainer = styled(ContentBackgroundContainer)`
  background-color: ${particlesBackgroundColor};
  z-index: ${zIndices.particles};
`;
const Overlay = styled(ContentBackgroundContainer)`
  background-image: ${overlayGradient};
  opacity: ${overlayOpacity};
  z-index: ${zIndices.overlay};
`;
const HeaderBackground = styled(HeaderContainer)`
  background-color: rgba(186, 203, 205, 0.5);
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  z-index: ${zIndices.headerBackground};
`;
//#endregion

interface Props extends SlideElementProps {
  zIndex: number;
}

const Background = React.forwardRef((props: Props, rootElRef: RefObject<HTMLDivElement>) => {
  const {zIndex} = props;
  const canvasContainerElIDRef = useRef<string>(uniqueId('landing-canvas-container-'));
  useEffect(() => {
    const {current: rootEl} = rootElRef;
    if (rootEl !== null) {
      particlesJS(canvasContainerElIDRef.current, particlesJSSettings);
    }
  }, []);
  const style: React.CSSProperties = {
    zIndex,
  };
  return (
    <Grid style={style} ref={rootElRef}>
      <CanvasContainer id={canvasContainerElIDRef.current}/>
      <HeaderBackground/>
      <Overlay/>
    </Grid>
  );
});

export default Background;
